// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Cr","title":"e_Dr","titleIcon":"e_Er","summary":"e_Fr","sourcesTitle":"e_Gr","sources":"e_Hr","source":"e_Ir"};